var _defs, _path, _g, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSticker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sentiment_satisfied_alt_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-3{fill:none}.cls-2{fill:#484848}.cls-3{stroke:#484848;stroke-width:2px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17816",
    "data-name": "Path 17816",
    className: "cls-1",
    d: "M0 0h20v20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21946",
    "data-name": "Group 21946",
    transform: "translate(5.733 6.667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1821",
    "data-name": "Ellipse 1821",
    className: "cls-2",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(5.933)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1822",
    "data-name": "Ellipse 1822",
    className: "cls-2",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17817",
    "data-name": "Path 17817",
    className: "cls-2",
    d: "M11.147 15.667A3.331 3.331 0 0 1 8.272 14H6.88a4.579 4.579 0 0 0 8.533 0h-1.391a3.32 3.32 0 0 1-2.875 1.667z",
    transform: "translate(-6.88 -9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_19910",
    "data-name": "Rectangle 19910",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h8.667a4 4 0 0 1 4 4v1.667a11 11 0 0 1-11 11H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    style: {
      stroke: "none"
    },
    transform: "translate(1.667 1.667)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4 1h8.667a3 3 0 0 1 3 3v1.667a10 10 0 0 1-10 10H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3z",
    transform: "translate(1.667 1.667)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17818",
    "data-name": "Path 17818",
    className: "cls-3",
    d: "M12.047 19.231a5.915 5.915 0 0 1 2.123-4.654 5.86 5.86 0 0 1 4.728-1.71",
    transform: "translate(-1.531 -1.76)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker);
export default __webpack_public_path__ + "static/media/sticker.3361eb5f8d43e9ff18f6660d9e2ecbc3.svg";
export { ForwardRef as ReactComponent };